export default __webpack_public_path__ + "static/rounded-4e15bde960fa4ef95b44efd6ed0ad49d.png";